import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

const tabFormFormList = (vars, linhaFormList, formListRadioGroup, jsonAcessoCliente, jsonIntegracao) => {

    let tabFormFormListAux = []

    const letras = 'abcde'

    let cont = -1

    cont++

    tabFormFormListAux.push(
        letras.substring(cont, cont + 1) + ') ' + LABEL.dadosCadastrais,
    )
    

    if (linhaFormList.informaFilhaos === "S") {
        
        cont++
        
        tabFormFormListAux.push(
            letras.substring(cont, cont + 1) + ') ' + LABEL.familiares,
        )
    }
    

    if (linhaFormList.informaObjetivos === "S" && (!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2)) {
        
        cont++

        tabFormFormListAux.push(
            letras.substring(cont, cont + 1) + ') ' + LABEL.objetivos,
        )
    }


    if (linhaFormList.informaPerfilCliente === "S" && (!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2)) {
        
        cont++

        tabFormFormListAux.push(
            letras.substring(cont, cont + 1) + ') ' + LABEL.perfilCliente,
        )
    }


    if (
            formListRadioGroup !== HARDCODE.formListPrimeiraReuniao ||
            jsonAcessoCliente.acessoCliente  || 
            linhaFormList.reportPrimeiraReuniaoInvestimentoSeguroVida === "S"
    ) {

        cont++

        tabFormFormListAux.push(
            letras.substring(cont, cont + 1) + ') ' + LABEL.perguntas,
        )
    }

    if (
            (
                (
                    formListRadioGroup !== HARDCODE.formListPrimeiraReuniao ||
                    linhaFormList.reportPrimeiraReuniaoInvestimentoSeguroVida === "S"
                ) &&
                vars.jsonUsuario.permitirInformarRiscos &&
                !jsonAcessoCliente.acessoCliente
            ) ||
            (
                (vars.jsonUsuario.utilizarEstudoCompleto || vars.jsonUsuario.permitirInformarRiscos) &&
                jsonAcessoCliente.acessoCliente && jsonAcessoCliente.disponibilizarInclusaoRevisaoRiscos 
            )
    ) {

        cont++

        tabFormFormListAux.push(
            letras.substring(cont, cont + 1) + ') ' + LABEL.riscos,
        )
    }


    return tabFormFormListAux
}

export default tabFormFormList